import React, { useCallback, useMemo } from 'react'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import { buildSearchParamsFromFilters } from 'lib/search/searchUtils'
import offerPageURL from 'lib/offer/offerPageURL'

import noop from 'lib/function/noop'
import { isTourV2Offer } from 'lib/offer/offerTypes'
import useOffers from 'hooks/Offers/useOffers'
import { EmptyArray, take } from 'lib/array/arrayUtils'
import MapSearchTile from './MapSearchTile/MapSearchTile'

interface Props {
  leOfferIds: Array<string>;
  bedbankOfferIds?: Array<string>;
  filters: App.OfferListFilters;
  onProductClick?: (offer: App.Offer | Tours.V2Offer | App.OfferSummary | App.BedbankOffer | App.BedbankOfferSummary, position: number) => void;
  onDeselectOffers?: () => void;
}

function SearchResultsMapOfferView(props: Props) {
  const { leOfferIds, bedbankOfferIds = EmptyArray, filters, onProductClick, onDeselectOffers } = props

  const offerIds = useMemo(() => take([...leOfferIds, ...bedbankOfferIds], 4), [bedbankOfferIds, leOfferIds])
  const [allOffers] = useOffers(offerIds)

  const offers = useMemo(
    () => allOffers.filter(offer => !isTourV2Offer(offer)) as Array<App.Offer | App.OfferSummary | App.BedbankOffer | App.BedbankOfferSummary>,
    [allOffers],
  )

  const offer = offers[0]

  const onClick = useCallback(() => {
    if (onProductClick) {
      onProductClick(offer, 0)
    }
  }, [offer, onProductClick])

  const urlParams = buildSearchParamsFromFilters(filters)

  if (!offer) {
    return null
  }
  return (
    <ClickableLink
      key={offer.id}
      to={`${offerPageURL(offer)}?${urlParams}`}
      onClick={onClick}
      preventSwipeClick
      target="_blank"
    >
      <MapSearchTile offer={offer} filters={filters} onClose={onDeselectOffers} />
    </ClickableLink>
  )
}

SearchResultsMapOfferView.defaultProps = {
  onProductClick: noop,
}

export default SearchResultsMapOfferView
